export const shouldShowFallbackWaitingBubble = ({
  isOrbAnchor = false,
  loadingResponse = false,
  responseTextHasStarted = false,
  hasEnteredLiveTextPhase = false,
  showLoadingOrbit = false,
  loadingPhaseMessage = "",
} = {}) => (
  Boolean(isOrbAnchor) &&
  Boolean(loadingResponse) &&
  !responseTextHasStarted &&
  !hasEnteredLiveTextPhase &&
  !showLoadingOrbit &&
  !String(loadingPhaseMessage || "").trim()
);
